function alertDialogOk(dialogname) {
  // var currentId = dialogname.target.dataset.alertid
  document.getElementById(dialogname + "-dialog").style.display = "none";
  document.getElementById(dialogname + "-overlay").style.display = "none";
}

function alertModal(dialogname) {
  // var currentId = dialogname.target.dataset.alertid
  // console.log(dialogname.target.dataset.alertid)
  var winW = window.innerWidth;
  var winH = window.innerHeight;
  var dialogoverlay = document.getElementById(dialogname + "-overlay");
  var dialogbox = document.getElementById(dialogname + "-dialog");

  dialogoverlay.style.display = "block";
  dialogoverlay.style.height = winH + "px";
  //dialogbox.style.top = "245px";
  dialogbox.style.display = "block";

  /**
   * Allows esc key to close existing modal
   */
  jQuery(document).on("keydown", function (event) {
    if (event.keyCode == 27) {
      document.getElementById(dialogname + "-dialog").style.display = "none";
      document.getElementById(dialogname + "-overlay").style.display = "none";
    }
  });

  /**
   * Click outside the modal to close
   */
  jQuery(document).on("click", function (event) {
    if (event.target == dialogoverlay) {
      document.getElementById(dialogname + "-dialog").style.display = "none";
      document.getElementById(dialogname + "-overlay").style.display = "none";
    }
  });
}

// function buttonPopup() {
//   console.log("ss")
//  // jQuery('.mobile-explosive-atc-button.button-disabled').on('click', function () {
//       alertModal('iStock');
//  // });
// }
jQuery(document).ready(function () {
  // function getCurrentPSTTime() {
  //   // const currentDate = new Date();
  //   // const utcOffset = -1; // PST is UTC-8
  //   // console.log(currentDate.getTime());

  //   // const pstTime = new Date(
  //   //   currentDate.getTime() + utcOffset * 60 * 60 * 1000
  //   // );
  //   // return pstTime;
  //   return new Date();

  // }
  // function checkStockAvailability() {
  //   const pstCurrentTime = new Date();
  //   console.log(pstCurrentTime);
  //   const currentDay = pstCurrentTime.getDay();
  //   const currentHour = pstCurrentTime.getHours();
  //   const currentMinute = pstCurrentTime.getMinutes();
  //   const isWeekend = currentDay === 0 || currentDay === 6;
  //   if (isWeekend || (currentDay === 5 && currentHour >= 14)) {
  //     return "In Stocks - Ships Monday";
  //   }
  //   else if (currentDay >= 1 && currentDay <= 5) {
  //     if ( (currentHour === 0 && currentMinute >= 1) || (currentHour > 0 && currentHour >= 14) ) {
  //       return "In Stocks - Ships Today";
  //     }
  //     else {
  //       return "In Stocks - Ships Tomorrow";
  //     }
  //   }
  // }

  function checkStockAvailability() {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const now = new Date();
    const dayOfWeek = now.getDay();
    const hour = now.getHours();
    const minute = now.getMinutes();
    const second = now.getSeconds();
    // console.log(now);

    // Check if the order was placed on Saturday or Sunday
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      jQuery("#availability_inline").removeClass("d-none");
      return "In Stock - Ships Monday";
    }

    // Check if the order was placed on Friday after 13:59:59
    if (dayOfWeek === 5 && hour >= 14 && minute >= 0 && second >= 0) {
      jQuery("#availability_inline").removeClass("d-none");
      return "In Stock - Ships Monday";
    }

    // Check if the order was placed between Monday and Friday before 14:00:00
    if (dayOfWeek >= 1 && dayOfWeek <= 5 && hour < 14) {
      jQuery("#availability_inline").removeClass("d-none");
      return "In Stock - Ships Today";
    }

    // For all other cases (order placed between Monday and Friday after 14:00:00)
    jQuery("#availability_inline").removeClass("d-none");
    return "In Stock - Ships Tomorrow";
  }

  // Example usage:
  const deliveryStatus = checkStockAvailability();
  // console.log(deliveryStatus);

  // Example usage
  const stockAvailability = checkStockAvailability();
  const availability_inline = document.querySelector("#availability_inline");
  const explosive_availability = document.querySelectorAll(
    ".explosive-availability"
  );
  const cart_availability = document.querySelectorAll(".cart-availability");
  const mb_explosive_availability = document.querySelector(
    ".mobile-explosive-availability"
  );
  // console.log(stockAvailability);
  if (availability_inline) {
    availability_inline.textContent = stockAvailability;
  }
  if (mb_explosive_availability) {
    setTimeout(function () {
      mb_explosive_availability.textContent = stockAvailability;
    }, 1000);
  }
  if (explosive_availability) {
    for (let i = 0; i < explosive_availability.length; i++) {
      explosive_availability[i].textContent = stockAvailability;
    }
  }
  if (cart_availability) {
    for (let i = 0; i < cart_availability.length; i++) {
      cart_availability[i].textContent = stockAvailability;
    }
  }

  jQuery(".gallery-thumbs .swiper-slide").click(function () {
    var stockAvailability = checkStockAvailability();
    var mb_explosive_availability = document.querySelector(
      ".mobile-explosive-availability"
    );
    var variant_stock = document.querySelector(".variant-stock").textContent;
    if (mb_explosive_availability) {
      // setTimeout(function () {
      mb_explosive_availability.textContent = stockAvailability;
      // }, 100)
      if (variant_stock == 0) {
        jQuery(".mobile-explosive-availability").hide();
      } else {
        jQuery(".mobile-explosive-availability").show();
      }
    }
  });

  // Quantity Selector
  function updateQuantityOptions() {
     // console.log("updateQuantityOptions")
    setTimeout(function () {
       // console.log("if mai han ")
      jQuery(
        ".product-form__action-wrapper .quantity-selector__label"
      ).removeClass("d-none");
      jQuery(".product-form__action-wrapper .quantity-selector").css(
        "display",
        "none"
      );
      jQuery(".product-form--atc-qty").removeClass("d-none");

      var dataQty = jQuery(".variant-selection__variants option:selected").attr(
        "data-varqty"
      );
      // dataQty = 14
      if (dataQty > 0) {
        jQuery(
          ".product-form__action-wrapper .product-form--atc-button .atc-button--text"
        ).text("Add to cart");
        jQuery(
          ".product-form__action-wrapper .product-form--atc-button"
        ).removeClass("soldBtn");
        jQuery(".form-field--qty-select .form-field-select").removeClass(
          "blockQtySlt"
        );

        if (dataQty !== undefined) {
          var quantityInput = jQuery(
            ".product-form__action-wrapper .quantity-selector__input"
          );
          var plusButtonWrapper = jQuery(
            ".product-form__action-wrapper .quantity-selector__wrapper .quantity-selector__button-wrapper--plus"
          );
          var actionWrapper = jQuery(
            ".product-form__action-wrapper .quantity-selector__wrapper"
          );
          quantityInput.attr("max", dataQty);
          quantityInput.val(1);
          if (dataQty > 0) {
            actionWrapper.removeClass("disabledQuantity");
          } else {
            actionWrapper.addClass("disabledQuantity");
          }
          if (parseInt(quantityInput.val()) < parseInt(dataQty)) {
            plusButtonWrapper.removeClass(
              "quantity-selector__button-wrapper--disabled"
            );
          } else {
            plusButtonWrapper.addClass(
              "quantity-selector__button-wrapper--disabled"
            );
          }

          jQuery(".form-field--qty-select .form-field-select")
            .find("option")
            .remove()
            .end();
          for (let index = 1; index <= dataQty; index++) {
            if (index <= 12) {
              jQuery(".form-field--qty-select .form-field-select").append(
                `<option value="${index}">${index}</option>`
              );
              // return false;
            } else if (index == 13) {
              jQuery(".form-field--qty-select .form-field-select").append(
                `<option value="13">More</option>`
              );
            }
          }
          // console.log(dataQty, quantityInput.val());

          jQuery(".form-field--qty-select .form-field-select").on(
            "change",
            function () {
              var GetQty = jQuery(this).find(":selected").val();
              jQuery(".quantity-selector__input").val(GetQty);
              if (GetQty == 13) {
                // console.log('if')
                jQuery(".product-form__action-wrapper .quantity-selector").css(
                  "display",
                  "block"
                );
                jQuery(".product-form--atc-qty").addClass("d-none");
                // jQuery('.product-form__action-wrapper .quantity-selector__label').addClass('d-none');
              }
            }
          );
        }
      } else {
        jQuery(
          ".product-form__action-wrapper .product-form--atc-button .atc-button--text"
        ).text("Sold Out");
        jQuery(
          ".product-form__action-wrapper .product-form--atc-button"
        ).addClass("soldBtn");
        jQuery(".form-field--qty-select .form-field-select")
          .find("option")
          .remove()
          .end();
        jQuery(".form-field--qty-select .form-field-select").append(
          `<option value="0">0</option>`
        );
        jQuery(".form-field--qty-select .form-field-select").addClass(
          "blockQtySlt"
        );

        // console.log("else")
      }
    }, 1500);
  }

  setTimeout(function () {
    updateQuantityOptions()
  }, 500);
  
  function updatePrice() {
    setTimeout(function () {
      var dataprice = jQuery(
        ".variant-selection__variants option:selected"
      ).attr("data-varprice");
      var datacprice = jQuery(
        ".variant-selection__variants option:selected"
      ).attr("data-varcprice");
      jQuery(".product-block--price .price--main .money").text(dataprice);
      jQuery(".product-block--price .price--compare-at .money").text(
        datacprice
      );
      // console.log(dataprice,datacprice);
    }, 100);
  }

  jQuery(".options-selection__option-value-label").change(function () {
    updateQuantityOptions();
    // updatePrice();
  });
  // jQuery(".product-form__action-wrapper .quantity-selector__button").click(function() {
  //   updateQuantityOptions();
  //   updatePrice();
  // });

  // let searchParams = new URLSearchParams(window.location.search)
  // if(!searchParams.has('variant')){
  //     console.log('aaaaaa')
  // setTimeout(function() {
  //   jQuery(".options-selection__option-value--selected label input").trigger("click");
  // }, 3000);

  // setTimeout(function() {
  //   jQuery('.slideNo1').trigger('click');
  // }, 2000);

  function changeAPiCall(variantId, qtyVal) {
    // Make the API call using jQuery's post method
    var requestData = {
      quantity: qtyVal,
      id: variantId,
    };
    jQuery
      .post("/cart/change.js", requestData)
      .done(function (response) {
        // Handle the API response here
        // console.log('API response:', response);
        var parseJson = JSON.parse(response);
        // itemTotal.innerHTML = Shopify.formatMoney(cartItem.price * cartItem.quantity, this.settings.money_format);
        jQuery(parseJson.items).each(function (index, item) {
          // console.log(item.id)
          if (item.id == parseInt(variantId)) {
            jQuery(
              '.cart-item[data-cartitem-id="' +
                variantId +
                '"] .cart-item__total .money'
            ).text(Shopify.formatMoney(item.final_line_price));
          }
        });
        jQuery(".cart-subtotal .money").text(
          Shopify.formatMoney(parseJson.original_total_price)
        );
        jQuery(".cart-title-total--large .cart-title-total .money").text(
          Shopify.formatMoney(parseJson.original_total_price)
        );
        jQuery(".site-header-cart--count").attr(
          "data-header-cart-count",
          parseJson.item_count
        );
      })
      .fail(function (xhr, status, error) {
        // Handle any errors that occur during the API call
        // console.error('Error:', error);
      });
  }

  jQuery(".cart-item--quantity .form-field--qty-select select").each(function (
    index
  ) {
    jQuery(this).change(function () {
      var variantId = jQuery(this).attr("data-variantId");
      var qtyVal = jQuery(this).find("option:selected").val();
      // console.log(qtyVal,variantId)
      jQuery(this)
        .closest(".cart-item--quantity")
        .find(".customQtyInput")
        .val(qtyVal);
      if (qtyVal > 12) {
        jQuery(this)
          .closest(".form-field--qty-select")
          .removeClass("visible")
          .addClass("hidden");
        jQuery(this).attr("tabindex", "-1");
        jQuery(this)
          .closest(".cart-item--quantity")
          .find(".form-field--qty-input")
          .removeClass("hidden")
          .addClass("visible");
        jQuery(this)
          .closest(".cart-item--quantity")
          .find(".customQtyInput")
          .focus()
          .removeAttr("tabindex")
          .select();
        // console.log("focus")
      }
      changeAPiCall(variantId, qtyVal);
    });
  });

  jQuery(".form-field--qty-input .customQtyInput").each(function (index) {
    jQuery(this).on("keyup", function () {
      // console.log("blur")
      var variantId = jQuery(this).attr("data-variantId");
      var maxCartQty = jQuery(this).attr("data-cartQty");
      var qtyVal = parseInt(jQuery(this).val());
      var qtyVal1 = jQuery(this);
      // console.log(qtyVal)
      if (!isNaN(qtyVal)) {
        // console.log(qtyVal)
        if (maxCartQty >= qtyVal) {
          changeAPiCall(variantId, qtyVal);
          jQuery(this).val(qtyVal);
        } else {
          // console.log('else')
          jQuery(this).val(maxCartQty);
          changeAPiCall(variantId, maxCartQty);
          jQuery(qtyVal1)
            .closest(".cart-item--quantity")
            .addClass("show_maxQtyMsg");
          setTimeout(function () {
            jQuery(qtyVal1)
              .closest(".cart-item--quantity")
              .removeClass("show_maxQtyMsg");
          }, 3000);
        }
      }
      // else{
      //   var xxx = qtyVal1;
      //   setTimeout(function(){
      //     console.log('else',xxx)
      //     console.log(variantId)
      //     jQuery(qtyVal1).val(1)
      //     changeAPiCall(variantId, 1)
      //   }, 2000);
      // }
    });
  });

  jQuery(".form-field--qty-input .customQtyInput").each(function (index) {
    var variantId = jQuery(this).attr("data-variantId");
    var maxCartQty = jQuery(this).attr("data-cartQty");
    var qtyVal = jQuery(this).val();
    if (qtyVal >= 13) {
      jQuery(this)
        .closest(".form-field--qty-select")
        .removeClass("visible")
        .addClass("hidden");
      // jQuery(this).attr('tabindex', '-1');
      jQuery(this)
        .closest(".cart-item--quantity")
        .find(".form-field--qty-input")
        .removeClass("hidden")
        .addClass("visible");
      // jQuery(this).closest('.cart-item--quantity').find('.customQtyInput').removeAttr('tabindex').select();
    }
  });

  // jQuery(".options-selection__option-value input").each(function () {
  //   jQuery(this).change(function () {
  //     var dataVariant = jQuery(this).attr("data-variant-option-available");
  //     console.log("Testing" +dataVariant, typeof dataVariant);
  //     if (dataVariant == "false") {
  //       jQuery(".product-form--regular .iStock-wrapper").show();
  //       jQuery("#product-form--availability").hide();
  //     } else {
  //       jQuery(".product-form--regular .iStock-wrapper").hide();
  //       jQuery("#product-form--availability").show();
  //     }
  //   });
  // });

    jQuery(".options-selection__option-value input").each(function () {
      // Bind both 'change' and 'click' events to each input element
      jQuery(this).on("change click", function () {
        var dataVariant = jQuery(this).attr("data-variant-option-available");
        console.log("Testing " + dataVariant, typeof dataVariant);
        
        if (dataVariant === "false") {
          jQuery(".product-form--regular .iStock-wrapper").show();
          jQuery("#product-form--availability").hide();
        } else {
          jQuery(".product-form--regular .iStock-wrapper").hide();
          jQuery("#product-form--availability").show();
        }
      });
    });

  

  jQuery(".explosive-variant-image-button").on("click", function () {
    let targetModal = $("#explosive-target-content");
    let targetModalImg = targetModal.find("img");

    targetModal.find("label").html($(this).data("color"));
    //targetModal.find('img').attr('src', $(this).data('img'));
    $(targetModalImg).attr("src", $(this).data("img"));

    if ($(this).data("img-zoom")) {
      $(targetModalImg).attr("data-zoom", $(this).data("img-zoom"));
    } else {
      $(targetModalImg).removeClass("image-zoom");
    }

    // refreshZoom();
    alertModal("explosive-target");
  });
});

// jQuery(window).on('load', function() {
//     console.log("load")
//     jQuery('#CountryList li a').click(function(){
//         console.log("Click")
//         var targatedCurrency = jQuery(this).attr('data-ct');
//         localStorage.setItem("targatedCurrency", targatedCurrency);
//         console.log(targatedCurrency)
//     })

//     setTimeout(function(){
//       var getTargatedCurrency = localStorage.getItem("targatedCurrency");
//       console.log(getTargatedCurrency)
//       // var verifyCurrency = $("input[name=country_code]").val();
//       var verifyCurrency = $(".sltCurrency").first().text();
//       console.log(verifyCurrency)
//       if(getTargatedCurrency != "" && getTargatedCurrency != null){
//         console.log("In If")
//           if(getTargatedCurrency == verifyCurrency){
//               console.log("Match")
//           }
//           else{
//               console.log("Not Match")
//               window.location.reload();
//           }
//       }
//     }, 5000);
// });

// jQuery( document ).ready(function() {
//   jQuery('.varNo_2').click();
//   setTimeout(function() {
//     jQuery('.varNo_1').click();
//   }, 2000);
// });

jQuery(document).ready(function () {
  var currLoc = window.location.href;
  var variantId = getParameterByName("variant", currLoc);
  // jquery onload check varint qty
  setTimeout(function () {
    $(".variantQuantityBox .variantQty").each(function () {
      var crtid = parseInt($(this).attr("id"));
      var qtyvariantId = parseInt($(this).attr("data-qty"));

      if (variantId == crtid) {
        if (qtyvariantId > 1) {
          console.log('data-qty is greater than 1');
        } else {
          console.log('data-qty is not greater than 1');
          // jQuery(".product-form--regular .iStock-wrapper").show();
        }
      }

      if (qtyvariantId > 1) {
        // console.log('data-qty is greater than 1');
      } else {
        setTimeout(function () {
          console.log('data-qty is not greater than 1');
          // jQuery(".product-form--regular .iStock-wrapper").show();
        }, 4000);
      }
    });
  }, 5000);

  // Function to get the value of a URL parameter by name
  function getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
});
